// service/contact/hooks/useCreateContactMutation.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contactApi, contactQueryKeys } from "service/crm/api/contact";

export const useCreateContactMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: contactApi.createContact,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: contactQueryKeys.all });
    },
  });
};

